export function triggerHaptic(type = "light") {

    /* Web standard vibration (Android) */
    if (navigator.vibrate) {

        if (type === "light") navigator.vibrate(10)
        if (type === "medium") navigator.vibrate(20)
        if (type === "heavy") navigator.vibrate([20, 30, 20])

    }

    /* iOS Safari workaround */
    if (window?.webkit?.messageHandlers?.haptic) {
        window.webkit.messageHandlers.haptic.postMessage(type)
    }

}

export function betAddedHaptic() {

    if (navigator.vibrate) {
        navigator.vibrate([10, 20, 10])
    }

}